import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, forkJoin, merge } from "rxjs";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { catchError, switchMap, tap } from "rxjs/operators";
import { PChekIns } from "src/app/models/ChkInPatDet";
import { DashCred } from "src/app/models/dash";
import { Diagnosis } from "src/app/models/diagnosis";
import { EditPatPresc } from "src/app/models/epresc";
import { laboratory_test } from "src/app/models/laboratory_test";
import { PatLabTest } from "src/app/models/labtest";
import { PatientD } from "src/app/models/Pdetails";
import { PatDiag } from "src/app/models/pdiag";
import { physician_specialities } from "src/app/models/physician_specialities";
import { PatPresc } from "src/app/models/presc";
import { Reschedule } from "src/app/models/reschedule";
import { environment } from "src/environments/environment";
// import { environment } from "src/environments/environment.qa";
import { AppHabbitList } from "./../../models/apphabbit";
import { Appointment } from "./../../models/appointment";
import { Checkout } from "./../../models/Checkout";
import { Extend } from "./../../models/extend";
import { FrontDesk } from "./../../models/frontDesk";
import { Organisation } from "./../../models/organisation";
import { AllPatient } from "./../../models/patient";
import { Physician } from "./../../models/physician";
import { ReadCount } from "./../../models/readCount";
import { Checkin } from "./../../models/scheckin";
import { User } from "./../../models/user";
import { UsrCred } from "./../../models/usrcred";
import { OrgService } from "./../../models/orgsrv";
import { Transactions } from "src/app/models/transactions_model";
import { patientAppointment } from "src/app/models/patientAppointment";
import { CouponDetails } from "src/app/models/CouponDetails";
import { ChatMessages } from "src/app/models/chat-model";
const axios = require("axios").default;

const httpOptions = {
  headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable({
  providedIn: "root",
})
export class VproService {
  httpClient: any;
  private user = new BehaviorSubject<string>("");
  cast = this.user.asObservable();
  public notificationUpdate: BehaviorSubject<object> = new BehaviorSubject(
    null
  );
  public consultNowUpdate: BehaviorSubject<object> = new BehaviorSubject(null);
  public chatMessageSubject: BehaviorSubject<object> = new BehaviorSubject(
    null
  );
  constructor(private http: HttpClient) { }

  /*@Purpose: url key for data access
   * @author: bhanuwhite
   * @ return : key data
   * @Date: 6th Feb 2019
   */

  getPatients(): Observable<AllPatient[]> {
    return this.http.get<AllPatient[]>(
      environment.api_base_url1 + "all/getAllPat"
    ); // serverless- patient , VT
  }

  // Retrieve Org Details
  getExtendDetails(): Observable<Extend[]> {
    return this.http.get<Extend[]>(
      environment.api_base_url1 + "gorgEx/getExOrg"
    );
  }

  /**api addPatients for add the patients */
  addPatients(allpatients, ppFile: File = null): Observable<AllPatient> {
    let finalResponse;
    return this.http
      .post<AllPatient>(
        environment.api_base_url3 + "patients",
        JSON.stringify(allpatients),
        httpOptions
      )
      .pipe(
        switchMap((response: any) => {
          finalResponse = response;
          // Get the signed url
          if (response && response.ppurl && ppFile) {
            return this.http.put(response.ppurl, ppFile);
          }

          return of(response);
        })
      )
      .pipe(
        switchMap(() => {
          return of(finalResponse);
        })
      );
  } // serverless- patient , VT


  /**api addPatients for add the patients */
  newaddPatients(allpatients, ppFile: File = null): Observable<AllPatient> {
    console.log("allpatients", allpatients)
    console.log("ppFile", ppFile)
    let finalResponse;
    return this.http
      .post<AllPatient>(
        environment.api_base_url3 + "newpatients",
        JSON.stringify(allpatients),
        httpOptions
      )
      .pipe(
        switchMap((response: any) => {
          finalResponse = response;
          // Get the signed url
          if (response && response.ppurl && ppFile) {
            return this.http.put(response.ppurl, ppFile);
          }

          return of(response);
        })
      )
      .pipe(
        switchMap(() => {
          return of(finalResponse);
        })
      );
  } // serverless- patient , VT



  // Add Medcine master
  addMedicinemaster(input): Observable<any> {
    console.log("input  input", input)
    return this.http.post<any>(
      environment.api_base_url3 + "/org_srv/medicine/add/",
      { ...input },
      httpOptions
    );
  }

  // Add Medcine category
  addMedicinecategory(input): Observable<any> {
    console.log("input  input", input)
    return this.http.post<any>(
      environment.api_base_url3 + "/org_srv/medicine/addcate/",
      { ...input },
      httpOptions
    );
  }

  // Add Medcine sub Category
  addMedicinesubcategory(input): Observable<any> {
    console.log("input  input", input)
    return this.http.post<any>(
      environment.api_base_url3 + "/org_srv/medicine/addsubcate/",
      { ...input },
      httpOptions
    );
  }



  // Retrive the sub category
  retriveMedsubcate(input): Observable<any> {
    console.log("input  input", input)
    return this.http.post<any>(
      environment.api_base_url3 + "/org_srv/medicine/subcate/",
      { ...input },
      httpOptions
    );
  }

  // get medicine Category
  getMedicinecategory(): Observable<any> {
    return this.http.get<any>(
      environment.api_base_url3 + "/org_srv/medicine/cate"
    );
  }

  // Illness  status  edit / delete -SYED
  editIllness(id, input) {
    return this.http.put<any>(
      environment.api_base_url3 + "/org_srv/illness/list/" + id,
      { ...input },
      httpOptions
    );
  }


  // save Illness List -SYED
  addIllnessList(input): Observable<any> {
    console.log("input  input", input)
    return this.http.post<any>(
      environment.api_base_url3 + "/org_srv/illness/addlist/",
      { ...input },
      httpOptions
    );
  }

  // get Illness List -SYED

  getIllnessList(): Observable<any> {
    return this.http.get<any>(
      environment.api_base_url3 + "/org_srv/illness/list"
    );
  }

  // Labtest  status  edit / delete -SYED
  editLabtest(id, input) {
    return this.http.put<any>(
      environment.api_base_url3 + "/org_srv/labtest/list/" + id,
      { ...input },
      httpOptions
    );
  }


  // save Labtest List -SYED
  addLabtestList(input): Observable<any> {
    console.log("input  input", input)
    return this.http.post<any>(
      environment.api_base_url3 + "/org_srv/labtest/addlist/",
      { ...input },
      httpOptions
    );
  }

  // get Labtest List -SYED

  getLabtestList(): Observable<any> {
    return this.http.get<any>(
      environment.api_base_url3 + "/org_srv/labtest/list"
    );
  }


  // Retrive the Medicine
  fetchMedicineRecords(input): Observable<any> {
    console.log("input  input", input)
    return this.http.post<any>(
      environment.api_base_url3 + "/org_srv/medicine/search",
      { ...input },
      httpOptions
    );
  }
  // Add Prescription Template
  addPrescriptiontemplate(input): Observable<any> {
    console.log("input  input", input)
    return this.http.post<any>(
      environment.api_base_url3 + "/physicians/pretemplate/create",
      { ...input },
      httpOptions
    );
  }
  // medicine categories status  edit / delete category
  editMedcategory(id, input) {
    return this.http.put<any>(
      environment.api_base_url3 + "/org_srv/medicine/cate/" + id,
      { ...input },
      httpOptions
    );
  }


  // medicine sub categories status edit / delete sub category
  editMedsubcategory(id, input) {
    return this.http.put<any>(
      environment.api_base_url3 + "/org_srv/medicine/subcate/" + id,
      { ...input },
      httpOptions
    );
  }


  // medicine Records status edit / delete sub category
  editMedicineRecor(id, input) {
    return this.http.put<any>(
      environment.api_base_url3 + "/org_srv/medicine/medicine/" + id,
      { ...input },
      httpOptions
    );
  }



  //Search PrescriptionTemplate
  sarchpresTempl(input): Observable<any> {
    return this.http.post<any>(
      environment.api_base_url3 + "/physicians/pretemplate/fetch",
      { ...input },
      httpOptions
    );
  }

  // delete a prescription from template
  editPresctmpl(id) {
    return this.http.delete<any>(
      environment.api_base_url3 + "physicians/pretemplate/" + id,
      httpOptions
    );
  }
  editnewPresctmpl(id, input) {
    return this.http.put<any>(
      environment.api_base_url3 + "physicians/pretemplate/" + id,
      { ...input },
      httpOptions
    );
  }



  emailvaild(data): Observable<any> {
    return this.http.post<any>(
      environment.api_base_url3 + "patient/fetch",
      JSON.stringify(data),
      httpOptions
    );
  }

  /**api to get data of patient on select */
  displayPat(allpatient) {
    //this.user.next(allpatient);
    return this.http.post(
      environment.api_base_url1 + "gpat/detailPat",
      JSON.stringify(allpatient),
      httpOptions
    );
  }
  /**api addFrontDesk for add the front desk */

  addFrontDesk(frontDesk: FrontDesk, ppFile: File): Observable<FrontDesk> {
    let finalResponse = null;
    return this.http
      .post<FrontDesk>(
        environment.api_base_url3 + "/users",
        JSON.stringify(frontDesk),
        httpOptions
      )
      .pipe(
        switchMap((response: any) => {
          finalResponse = response;
          // Get the signed url
          if (response && response.ppurl && ppFile) {
            return this.http.put(response.ppurl, ppFile);
          }

          return of(response);
        })
      )
      .pipe(
        switchMap(() => {
          return of(finalResponse);
        })
      );
  }

  updateFrontDesk(
    id,
    frontDesk: FrontDesk,
    ppFile: File
  ): Observable<FrontDesk> {
    let finalResponse = null;
    return this.http
      .put<FrontDesk>(
        environment.api_base_url3 + `/users/${id}`,
        JSON.stringify(frontDesk),
        httpOptions
      )
      .pipe(
        switchMap((response: any) => {
          finalResponse = response;
          // Get the signed url
          if (response && response.ppurl && ppFile) {
            return this.http.put(response.ppurl, ppFile);
          }

          return of(response);
        })
      )
      .pipe(
        switchMap(() => {
          return of(finalResponse);
        })
      );
  }

  searchFrontDesk(data): Observable<FrontDesk[]> {
    return this.http
      .post<FrontDesk[]>(
        environment.api_base_url3 + "/users/search",
        JSON.stringify(data),
        httpOptions
      )
      .pipe(
        switchMap((res) => {
          if (res && res.length > 0) {
            for (let user of res) {
              if (user.ppurl) {
                user.ppurl = environment.content_base_url + "/" + user.ppurl;
              } else {
                user.ppurl =
                  environment.content_base_url + "/" + environment.dummy_img;
              }
            }
          }
          return of(res);
        })
      );
  }

  deleteUsers(type: String, data): Observable<any> {
    return this.http.put<FrontDesk>(
      environment.api_base_url3 + `/${type}/delete`,
      JSON.stringify(data),
      httpOptions
    );
  }

  getFrontDeskById(id: String): Observable<FrontDesk> {
    return this.http
      .get<FrontDesk>(environment.api_base_url3 + `users/${id}`)
      .pipe(
        switchMap((res) => {
          if (res && res.ppurl) {
            res.ppurl = environment.content_base_url + "/" + res.ppurl;
          } else {
            res.ppurl =
              environment.content_base_url + "/" + environment.dummy_img;
          }
          return of(res);
        })
      );
  }

  // Duplicate
  /*  searchDoctorDesk(data): Observable<Physician[]> {
     return this.http
       .post<Physician[]>(
         environment.api_base_url3 + "/physicians/search",
         JSON.stringify(data),
         httpOptions
       )
       .pipe(
         switchMap((res) => {
           if (res && res.length > 0) {
             for (let user of res) {
               if (user.ppurl) {
                 user.ppurl = environment.content_base_url + "/" + user.ppurl;
               } else {
                 user.ppurl =
                   environment.content_base_url + "/" + environment.dummy_physician_img;
               }
             }
           }
           return of(res);
         })
       );
   } */

  displayAppoint(appointment, pagination = "") {
    return this.http.post(
      environment.api_base_url1 + "patient/Checkin" + `?${pagination}`,
      JSON.stringify(appointment),
      httpOptions
    );
  }

  getcheckinId(cid): Observable<Checkin[]> {
    return this.http.get<Checkin[]>(
      environment.api_base_url1 + "checkin/" + cid
    );
  }
  /**api addUser for add the user */
  addUser(user: User): Observable<User> {
    return this.http.post<User>(
      environment.api_base_url1 + "user/adduser",
      JSON.stringify(user),
      httpOptions
    );
    // subject.next(uservar)
  }

  /**api addOrg for add the organization*/
  addOrg(organisation: Organisation): Observable<Organisation> {
    return this.http.post<Organisation>(
      environment.api_base_url1 + "org/addorg",
      JSON.stringify(organisation),
      httpOptions
    );
  }

  /**api addExtend for add the extend*/
  addExtend(data): Observable<{}> {
    return this.http.post<{}>(
      environment.api_base_url2 + "orgEx/addOrgEx",
      JSON.stringify(data),
      httpOptions
    ); // serverless- physician extend , VT
  }

  /** api addAllPhysician for add the physician*/
  addAllPhysician(physician): Observable<Physician> {
    return this.http.post<Physician>(
      environment.api_base_url1 + "phy/addPhy",
      JSON.stringify(physician),
      httpOptions
    );
  }

  /**api getPhysicianDetails for getting the physician list */
  getPhysicianDetails(): Observable<Physician[]> {
    return this.http.get<Physician[]>(
      environment.api_base_url2 + "phy/concate"
    );
  }

  /**api addACheckin for checkin */
  addACheckin(checkin) {
    return this.http.post<Checkin>(
      environment.api_base_url1 + "check/addcheckin",
      JSON.stringify(checkin),
      httpOptions
    );
  }
  /**copy appointment to checkin */
  getcheckin(): Observable<Checkin[]> {
    return this.http.get<Checkin[]>(
      environment.api_base_url2 + "checkout/getdetail"
    );
  }

  requestOTP(phone): Observable<any> {
    return this.http.post<any>(
      environment.api_base_url3 + "users/otp",
      JSON.stringify(phone),
      httpOptions
    );
  }

  validateOTP(body): Observable<any> {
    return this.http.put<any>(
      environment.api_base_url3 + "users/otp",
      JSON.stringify(body),
      httpOptions
    );
  }

  /**api addSchedule/Appointment Calendar*/
  addSchedule(appointment, charge = "") {
    let qp = charge ? "?charge=true" : "";
    console.log("url", environment.api_base_url1 + `appoint/addAppoint${qp}`)
    return this.http.post(
      environment.api_base_url1 + `appoint/addAppoint${qp}`,
      JSON.stringify(appointment),
      httpOptions
    );
  }
  /**api addSchedule/Appointment Calendar*/
  addAdhocSchedule(appointment, charge = "") {
    let qp = charge ? "?charge=true" : "";
    console.log("url", environment.api_base_url1 + `appoint/addAdhocAppoint${qp}`)
    return this.http.post(
      environment.api_base_url1 + `appoint/addAdhocAppoint${qp}`,
      JSON.stringify(appointment),
      httpOptions
    );
  }
  /** Edit reschedule/Appointment API for doctors calendar*/
  editSchedule(appointment, aid, charge = "") {
    let qp = charge ? "?charge=true" : "";
    console.log("-----------------      appointment     ==========================", appointment)
    console.log("-----------------      aid     ==========================", aid)
    console.log("-----------------      URL     ==========================")

    console.log(environment.api_base_url1 + `appointment / ${aid}${qp}`)
    return this.http.put(
      environment.api_base_url1 + `appointment/${aid}${qp}`,
      JSON.stringify(appointment),
      httpOptions
    );
  }

  /** Delete Appointment API for doctors calendar*/
  deleteAppointment(aid: any, uid: any): Observable<Appointment> {
    return this.http.delete<Appointment>(
      `${environment.api_base_url1}appoint/deleteAppoint/${aid}/${uid}`,
      httpOptions
    );
  }

  getWorkingHours(did): Observable<any> {
    return this.http.get<any>(
      environment.api_base_url3 + `physicians/availability/${did}`
    );
  }

  updateWorkingHours(input, did): Observable<any> {
    return this.http.put<any>(
      environment.api_base_url3 + `physicians/availability/${did}`,
      { ...input },
      httpOptions
    );
  }

  getConsultNow(uid): Observable<any> {
    return this.http.get<any>(
      environment.api_base_url3 + `physicians/consultnow/${uid}`
    );
  }

  setConsultNow(uid, input): Observable<any> {
    return this.http.put<any>(
      environment.api_base_url3 + `physicians/consultnow/${uid}`,
      { ...input },
      httpOptions
    );
  }

  /**api authUser for authuser */
  authUser(usrcred: UsrCred): Observable<UsrCred> {
    return this.http.post<User>(
      environment.api_base_url1 + "usr/auth",
      JSON.stringify(usrcred),
      httpOptions
    );
  }

  /**api authUser for authuser */
  authUser2(usrcred: UsrCred): Observable<UsrCred> {
    return this.http.post<User>(
      environment.api_base_url1 + "usr/eid",
      JSON.stringify(usrcred),
      httpOptions
    );
  }

  /**function loggedIn for get the token from the localstorage */
  loggedIn() {
    return !!localStorage.getItem("token2");
  }

  /**function  getToken for get the token from local storage*/
  getToken() {
    return localStorage.getItem("token2");
  }
  /**api getSearchPhy for search the api */
  getSearchPhy(dcred: DashCred): Observable<Physician[]> {
    return this.http.post<Physician[]>(
      environment.api_base_url2 + "phy/concate",
      { usereid: localStorage.getItem("LogUsr") },
      httpOptions
    );
  }

  Phy(physiciand) {
    return this.http.post(
      environment.api_base_url1 + "search/getSearch",
      JSON.stringify(physiciand),
      httpOptions
    );
  }
  /**get appointment function */
  getappoint(obj = null): Observable<Appointment[]> {
    let qp = obj ? `?drid=${obj.drid}&date=${obj.date}` : "";
    console.log("qp", qp)
    return this.http.get<Appointment[]>(
      environment.api_base_url1 + "appoint/getAppointment" + qp
    );
  }

  /**get appointment function */
  getallappoint(obj = null): Observable<Appointment[]> {
    let qp = obj ? `?drid=${obj.drid}&cur_date=${obj.cur_date},&days=${obj.days}` : "";
    console.log("qp", qp)
    return this.http.get<Appointment[]>(
      environment.api_base_url1 + "appoint/getAppointment" + qp
    );
  }
  // Duplicate of getappoint and No where called
  /*  getSearchappoint(): Observable<Appointment[]> {
     return this.http.get<Appointment[]>(
       environment.api_base_url1 + "appoint/getAppointment"
     );
   } */

  /***get pat detail */

  getpat(cid): Observable<PatientD[]> {
    console.log("CID", cid);
    return this.http.get<PatientD[]>(
      environment.api_base_url1 + "data/getId/" + cid
    );
  }

  /***get pat profile details for checkin screen profiles*/

  getPatPro(pid): Observable<PatientD[]> {
    return this.http.get<PatientD[]>(
      environment.api_base_url2 + "patient/profile/" + pid
    );
  }

  /***get pat diag detail for checkin screen profiles*/

  getPatDiag(dcred: DashCred, pid): Observable<PatientD> {
    return this.http.post<PatientD>(
      environment.api_base_url2 + "patient/diag/" + pid,
      { usereid: localStorage.getItem("LogUsr") },
      httpOptions
    );
  }

  /***get pat History*/

  getPatHist(d_id): Observable<PatientD[]> {
    return this.http.get<PatientD[]>(
      environment.api_base_url2 + "pateint/hist/" + d_id
    );
  }

  /***get pat prescription detail for checkin screen profiles*/

  getPatPresc(dcred: DashCred, pid): Observable<PatientD> {
    return this.http.post<PatientD>(
      environment.api_base_url2 + "patient/presc/" + pid,
      { usereid: localStorage.getItem("LogUsr") },
      httpOptions
    );
  }

  /***get pat old prescription detail for checkin screen profiles*/

  getOldPatPresc(dcred: DashCred, pid): Observable<PatientD> {
    return this.http.post<PatientD>(
      environment.api_base_url2 + "patient/opresc/" + pid,
      { usereid: localStorage.getItem("LogUsr") },
      httpOptions
    );
  }

  /***get pat labtest detail for checkin screen profiles*/

  getPatLabTest(dcred: DashCred, pid): Observable<PatLabTest> {
    return this.http.post<PatLabTest>(
      environment.api_base_url2 + "patient/getlabtest/" + pid,
      { usereid: localStorage.getItem("LogUsr") },
      httpOptions
    );
  }

  getApcount(dcred: DashCred): Observable<ReadCount> {
    return this.http.post<ReadCount>(
      environment.api_base_url1 + "count/appointment",
      { usereid: localStorage.getItem("LogUsr") },
      httpOptions
    );
  }

  // Doctors count for AdminDash

  getDocCount(dcred: DashCred): Observable<any> {
    return this.http.post<any>(
      environment.api_base_url2 + "count/doctors",
      {
        usereid: localStorage.getItem("LogUsr"),
        orgcode: localStorage.getItem("orgcode"),
      },
      httpOptions
    );
  }




  fetchPayoutInvoice(input, params = ""): Observable<Physician[]> {
    console.log(environment.api_base_url3 + "org_srv/payout/search" + `${params}`,
      { ...input })
    return this.http
      .post<Physician[]>(
        environment.api_base_url3 + "org_srv/payout/search" + `${params}`,
        { ...input },
        httpOptions
      )
      .pipe(
        switchMap((res) => {
          return of(res);
        })
      );
  }






  fetchPhysicians(input, params = ""): Observable<Physician[]> {
    return this.http
      .post<Physician[]>(
        environment.api_base_url3 + "physicians/search" + `${params}`,
        { ...input },
        httpOptions
      )
      .pipe(
        switchMap((res) => {
          if (res && res["result"] && res["result"].length > 0) {
            for (let user of res["result"]) {
              if (user.ppurl) {
                user.ppurl = environment.content_base_url + "/" + user.ppurl;
              } else {
                user.ppurl =
                  environment.content_base_url +
                  "/" +
                  environment.dummy_physician_img;
              }
            }
          }
          return of(res);
        })
      );
  }

  fetchAllPatients(data, params = ""): Observable<AllPatient[]> {
    return this.http
      .post<AllPatient[]>(
        environment.api_base_url3 + "patients/search" + `${params}`,
        { ...data },
        httpOptions
      )
      .pipe(
        switchMap((res) => {
          if (res && res.length > 0) {
            for (let user of res) {
              if (user.ppurl) {
                user.ppurl = environment.content_base_url + "/" + user.ppurl;
              } else {
                user.ppurl =
                  environment.content_base_url + "/" + environment.dummy_img;
              }
            }
          }
          return of(res);
        })
      );
  }

  fetchPatients(data): Observable<AllPatient[]> {
    return this.http
      .post<AllPatient[]>(
        environment.api_base_url3 + "patients/search",
        JSON.stringify(data),
        httpOptions
      )
      .pipe(
        switchMap((res) => {
          if (res && res.length > 0) {
            for (let user of res) {
              if (user.ppurl) {
                user.ppurl = environment.content_base_url + "/" + user.ppurl;
              } else {
                user.ppurl =
                  environment.content_base_url + "/" + environment.dummy_img;
              }
            }
          }
          return of(res);
        })
      );
  }

  fetchPatientById(pid): Observable<AllPatient> {
    return this.http
      .get<AllPatient>(environment.api_base_url3 + "patients/" + pid)
      .pipe(
        switchMap((res) => {
          if (res && res.ppurl) {
            res.ppurl = environment.content_base_url + "/" + res.ppurl;
          } else {
            res.ppurl =
              environment.content_base_url + "/" + environment.dummy_img;
          }
          return of(res);
        })
      );
  }
  fetchPatientByAId(pid, cid): Observable<AllPatient> {
    return this.http
      .get<AllPatient>(environment.api_base_url3 + "patients/" + pid + `?aid=${cid}`)
      .pipe(
        switchMap((res) => {
          if (res && res.ppurl) {
            res.ppurl = environment.content_base_url + "/" + res.ppurl;
          } else {
            res.ppurl =
              environment.content_base_url + "/" + environment.dummy_img;
          }
          return of(res);
        })
      );
  }



  fetchPatientDiagnosisByPhysician(input): Observable<Diagnosis[]> {
    return this.http.post<Diagnosis[]>(
      environment.api_base_url3 + "patients/" + input.pid + "/diagnosis/search",
      { pid: input.pid, drid: input.drid },
      httpOptions
    );
  }




  fetchAppointTestsByPhysician(input): Observable<PatLabTest[]> {
    console.log("input.pid", input.pid)
    console.log("input.aid", input.aid)
    return this.http
      .post<PatLabTest[]>(
        environment.api_base_url3 +
        "patients/" +
        input.pid +
        "/current_labtests/search",
        { pid: input.pid, aid: input.aid },
        httpOptions
      )
      .pipe(
        switchMap((response) => {
          if (response && response.length > 0) {
            for (let test of response) {
              if (test.attachments && test.attachments.length > 0) {
                let reports = [];
                test.attachments.forEach((report) => {
                  reports.push(`${environment.content_base_url}/${report}`);
                });
                test.attachments = reports;
              }
            }
          }
          return of(response);
        })
      );
  }

  fetchPatientTestsByPhysician(input): Observable<PatLabTest[]> {
    return this.http
      .post<PatLabTest[]>(
        environment.api_base_url3 +
        "patients/" +
        input.pid +
        "/labtests/search",
        { pid: input.pid, drid: input.drid },
        httpOptions
      )
      .pipe(
        switchMap((response) => {
          if (response && response.length > 0) {
            for (let test of response) {
              if (test.attachments && test.attachments.length > 0) {
                let reports = [];
                test.attachments.forEach((report) => {
                  reports.push(`${environment.content_base_url}/${report}`);
                });
                test.attachments = reports;
              }
            }
          }
          return of(response);
        })
      );
  }

  fetchPatientPrescriptionsByPhysician(input): Observable<PatPresc[]> {
    return this.http.post<PatPresc[]>(
      environment.api_base_url3 +
      "patients/" +
      input.pid +
      "/prescriptions/search",
      { pid: input.pid, drid: input.drid },
      httpOptions
    );
  }

  CurrentPrescriptionPdf(body, params): Observable<any> {
    console.log("body", body)
    console.log("params", params)
    console.log(`${environment.api_base_url3}pdf${params}`)
    return this.http.post<any>(
      `${environment.api_base_url3}pdf${params}`,
      // environment.api_base_url3 + "pdf", + `${params}`,
      JSON.stringify(body),
      httpOptions
    );
  }

  fetchCheckinById(input): Observable<Checkin> {
    return this.http.get<Checkin>(
      environment.api_base_url3 +
      "patients/" +
      input.pid +
      "/checkin/" +
      input.cid
    );
  }

  addDiagnosis(input): Observable<any> {
    return this.http.post<any>(
      environment.api_base_url3 + "patients/" + input.pid + "/diagnosis",
      { ...input },
      httpOptions
    );
  }

  addPrescription(input, patid = ""): Observable<any> {
    console.log("input  input", input)
    let pid = patid ? patid : input.pid;
    console.log("input.pid", input.pid)
    console.log("pid", pid)
    return this.http.post<any>(
      environment.api_base_url3 + "patients/" + pid + "/prescriptions",
      { ...input },
      httpOptions
    );
  }

  updatePrescription(pid, input) {
    return this.http.put<any>(
      environment.api_base_url3 +
      "patients/" +
      pid +
      "/prescriptions/" +
      input.prid,
      { ...input },
      httpOptions
    );
  }

  getPrescription(params): Observable<any> {
    return this.http
      .get<any>(
        environment.api_base_url3 +
        "patients/prescriptions" +
        `?aptid=${params.aptid}&passcode=${params.passcode}${params.uid ? `&uid=${params.uid}` : ""
        }`
      )
      .pipe(
        switchMap((res) => {
          if (res && res.p_url) {
            res.p_url = environment.content_base_url + "/" + res.p_url;
          }

          if (
            res &&
            res.physician &&
            res.physician.length &&
            res.physician[0].ppurl
          ) {
            res.physician[0].ppurl =
              environment.content_base_url + "/" + res.physician[0].ppurl;
          } else {
            res.physician[0].ppurl =
              environment.content_base_url +
              "/" +
              environment.dummy_physician_img;
          }

          return of(res);
        })
      );
  }

  updateLabtest(pid, input, reports): Observable<any> {
    let finalResponse;
    return this.http
      .put<any>(
        environment.api_base_url3 +
        "patients/" +
        pid +
        "/labtests/" +
        input.testid,
        { ...input },
        httpOptions
      )
      .pipe(
        switchMap((response: any) => {
          finalResponse = response;
          // Get the signed url
          console.log(response);
          if (
            response &&
            response.attachments &&
            response.attachments.length > 0 &&
            reports
          ) {
            let attachments = {};
            response.attachments.forEach((attachment) => {
              attachments[attachment.name] = attachment.signedUrl;
            });
            let requests = [];
            reports.forEach((report) => {
              requests.push(this.http.put(attachments[report.name], report));
            });
            return forkJoin(requests);
          }
          return of(response);
        })
      )
      .pipe(
        switchMap(() => {
          return of(finalResponse);
        })
      );
  }

  addLabTests(input, pid): Observable<any> {
    return this.http.post<any>(
      environment.api_base_url3 + "patients/" + pid + "/labtests",
      { ...input },
      httpOptions
    );
  }

  updateCheckin(pid, input): Observable<any> {
    return this.http.put<any>(
      environment.api_base_url3 + "patients/" + pid + "/checkin/" + input.cid,
      { ...input },
      httpOptions
    );
  }

  // getApNames(dcred: DashCred): Observable<FetchAPNames> {
  //   return this.http.post<FetchAPNames>(environment.api_base_url1 + 'appoint/getQANames', {usereid: localStorage.getItem('LogUsr')}, httpOptions);
  // }

  /**get CheckIn Patient for a Physician */
  getCheckedInPats(data = null, pagination = ""): Observable<PChekIns> {
    return this.http.post<PChekIns>(
      environment.api_base_url1 + "patient/Pcheckins" + `?${pagination}`,
      { usereid: localStorage.getItem("LogUsr"), ...data },
      httpOptions
    );
  }

  //**get past appointment */
  getPastAppointments(data = null, pagination = ""): Observable<PChekIns> {
    return this.http.post<PChekIns>(
      environment.api_base_url1 + "appoint/getAppointment" + `?${pagination}`,
      { usereid: localStorage.getItem("LogUsr"), ...data },
      httpOptions
    );
  }

  // acnt actvtn mailer
  mailUser(usrcred: UsrCred): Observable<UsrCred> {
    return this.http.post<User>(
      environment.api_base_url1 + "test/sendmail",
      JSON.stringify(usrcred),
      httpOptions
    );
  }

  // alert deleted user
  mailDelUser(usermail: FrontDesk): Observable<FrontDesk[]> {
    return this.http.post<FrontDesk[]>(
      environment.api_base_url1 + "test/sendmail",
      JSON.stringify(usermail),
      httpOptions
    );
  }

  // pwd reset mailer
  mailUsrpwd(usrcred: UsrCred): Observable<UsrCred> {
    return this.http.post<User>(
      environment.api_base_url1 + "pwd/sendmail",
      JSON.stringify(usrcred),
      httpOptions
    );
  }

  // under test
  updUsr(usrcred: UsrCred): Observable<UsrCred> {
    return this.http.post<User>(
      environment.api_base_url1 + "user/upduser",
      { email_id: usrcred },
      httpOptions
    );
  }
  // save checkin stats data
  saveCheckin_stats(data): Observable<any> {
    return this.http.post<any>(
      environment.api_base_url3 + "newpatient/stats_detail",
      JSON.stringify(data),
      httpOptions
    );
  }


  // save consult screen data
  saveConsult_dtails(data): Observable<any> {
    console.log("data data  data", data)
    console.log(environment.api_base_url3 + "newpatient/consult",)
    return this.http.post<any>(
      environment.api_base_url3 + "newpatient/consult",
      JSON.stringify(data),
      httpOptions
    );
  }



  getstatList(): Observable<{}[]> {
    return this.http.get<{}[]>(
      environment.api_base_url3 + "/newpatient/stats"
    );
  }

  //  get the static detail with passing pig
  getStat_detail(params): Observable<any> {
    // console.log("params", params);
    // console.log("paramsparamsparams", "newpatient/stats_detail" +
    //   `?pid=${params.pid}&aid=${params.aid}`);
    if (params.aid) {
      console.log("params", params);
      console.log("paramsparamsparams", "newpatient/stats_detail" +
        `?pid=${params.pid}&aid=${params.aid}`);
      return this.http
        .get<any>(
          environment.api_base_url3 +
          "newpatient/stats_detail" +
          `?pid=${params.pid}&aid=${params.aid}`
        )
        .pipe(
          switchMap((res) => {
            return of(res);
          }
          ));
    }
    if (params.stats_id) {
      console.log("params", params);
      console.log("paramsparamsparams", "newpatient/stats_detail" +
        `?pid=${params.pid}&stats_id=${params.stats_id}`);
      return this.http
        .get<any>(
          environment.api_base_url3 +
          "newpatient/stats_detail" +
          `?pid=${params.pid}&stats_id=${params.stats_id}`
        )
        .pipe(
          switchMap((res) => {
            return of(res);
          }
          ));
    }
  }

  Checkin_s(cid, checkin): Observable<any> {
    return this.http
      .post(
        environment.api_base_url1 + "update/status/" + cid,
        JSON.stringify(checkin),
        httpOptions
      )
      .pipe(
        tap((_) => console.log(`updated patient checkin id=${cid}`)),
        catchError(this.handleError<any>("Checkin_s"))
      );
  }

  postCheckin(appointment) {
    return this.http.post(
      environment.api_base_url1 + "check/getcheckin",
      JSON.stringify(appointment),
      httpOptions
    );
  }

  /**api claimpass for lost password */
  claimAuth(usrcred: UsrCred): Observable<UsrCred> {
    return this.http.post<User>(
      environment.api_base_url1 + "usr/claimpass",
      JSON.stringify(usrcred),
      httpOptions
    );
  }

  setUserPass(usrcred: UsrCred): Observable<UsrCred> {
    return this.http.put<User>(
      environment.api_base_url1 + "user/upduserpass/:email_id",
      {
        email_id: usrcred.email_id,
        password: usrcred.password,
        account_type: usrcred.account_type,
      },
      httpOptions
    );
  }

  getAppointID(aid): Observable<PatientD[]> {
    return this.http.get<PatientD[]>(environment.api_base_url2 + "edit/" + aid);
  }

  checkoutUpdate(cid, checkin): Observable<any> {
    return this.http.put<Checkout>(
      environment.api_base_url2 + "checkout/status/" + cid,
      JSON.stringify(checkin),
      httpOptions
    );
  }

  statuscheckout(cid, checkin): Observable<any> {
    return this.http
      .post(
        environment.api_base_url2 + "checkout/status/" + cid,
        JSON.stringify(checkin),
        httpOptions
      )
      .pipe(
        tap((_) => console.log(`updated patient checkin id=${cid}`)),
        catchError(this.handleError<any>("statuscheckout"))
      );
  }

  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  Reschedule(aid, appointment): Observable<Appointment> {
    return this.http.put<Appointment>(
      environment.api_base_url2 + "reschedule/" + aid,
      JSON.stringify(appointment),
      httpOptions
    );
  }

  deleteAppoint(appointment: Appointment, aid): Observable<Appointment> {
    return this.http.put<Appointment>(
      environment.api_base_url2 + "delete/cancelled/" + aid,
      { aid: appointment.aid },
      httpOptions
    );
  }

  /**api addDiag for adding Diagnosis */
  addDiag(pdiag: PatDiag): Observable<PatDiag> {
    return this.http.post<PatDiag>(
      environment.api_base_url2 + "patient/diagadd",
      JSON.stringify(pdiag),
      httpOptions
    );
  }

  /**api addPresc for adding Prescription */
  addPresc(presc: PatPresc): Observable<PatPresc> {
    return this.http.post<PatPresc>(
      environment.api_base_url2 + "patient/prescadd",
      JSON.stringify(presc),
      httpOptions
    );
  }

  /**api to add diagnosis while creating patient profile */
  postDiagnosis(diagnosis): Observable<Diagnosis> {
    return this.http.post<Diagnosis>(
      environment.api_base_url2 + "post/diag",
      JSON.stringify(diagnosis),
      httpOptions
    );
  }

  updatePresc(aid, epresc): Observable<EditPatPresc> {
    return this.http.put<EditPatPresc>(
      environment.api_base_url2 + "patientpresc/" + aid,
      JSON.stringify(epresc),
      httpOptions
    );
  }

  /**api addLabTest for adding Lab Test */
  addLabTest(ltest: PatLabTest): Observable<PatLabTest> {
    return this.http.post<PatLabTest>(
      environment.api_base_url2 + "patient/addlabtest",
      JSON.stringify(ltest),
      httpOptions
    );
  }
  fetchPhysicianTransfers(queryParam = ''): Observable<any> {
    return this.http.get<any>(
      environment.api_base_url3 + `/transfers${queryParam}`,
      httpOptions
    )
  }

  processPhysicianPayout(
    data = null
  ): Observable<any[]> {
    return this.http.post<patientAppointment[]>(
      environment.api_base_url3 + "/transfers",
      JSON.stringify(data),
      httpOptions
    );
  }


  /**get Org_Code for new Physician */
  getOrgDet(dcred: DashCred): Observable<Physician> {
    return this.http.post<Physician>(
      environment.api_base_url2 + "physician/orgcd",
      { usereid: localStorage.getItem("LogUsr") },
      httpOptions
    );
  }

  getSpecialitiesList(): Observable<physician_specialities[]> {
    return this.http.get<physician_specialities[]>(
      environment.api_base_url3 + "/masterdata/physician_specialities"
    );
  }

  addSpecialities(data): Observable<physician_specialities[]> {
    return this.http.post<physician_specialities[]>(
      environment.api_base_url3 + "/masterdata/physician_specialities",
      JSON.stringify(data),
      httpOptions
    );
  }

  getLaboratoryTests(): Observable<laboratory_test[]> {
    return this.http.get<laboratory_test[]>(
      environment.api_base_url3 + "/masterdata/laboratory_tests"
    );
  }

  /**api addFrontDesk for add the front desk */

  addPhysician(data, ppFile: File): Observable<{}> {
    let finalResponse;
    return this.http
      .post<{}>(
        environment.api_base_url3 + "physicians",
        JSON.stringify(data),
        httpOptions
      )
      .pipe(
        switchMap((response: any) => {
          finalResponse = response;
          // Get the signed url
          if (response && response.ppurl && ppFile) {
            return this.http.put(response.ppurl, ppFile);
          }

          return of(response);
        })
      )
      .pipe(
        switchMap(() => {
          return of(finalResponse);
        })
      );
  }

  getPhysicianById(id: String, queryParam = ""): Observable<Physician> {
    return this.http
      .get<Physician>(
        environment.api_base_url3 + `physicians/${id}${queryParam}`
      )
      .pipe(
        switchMap((res) => {
          if (res && res.ppurl) {
            res.ppurl = environment.content_base_url + "/" + res.ppurl;
          } else {
            res.ppurl =
              environment.content_base_url +
              "/" +
              environment.dummy_physician_img;
          }
          if (res && res.s_url) {
            res.s_url = environment.content_base_url + "/" + res.s_url;
          }
          return of(res);
        })
      );
  }

  updatePhysician(
    id,
    physician: Physician,
    ppFile: File = null,
    signfile: File = null
  ): Observable<Physician> {
    let finalResponse = null;
    return this.http
      .put<Physician>(
        environment.api_base_url3 + `physicians/${id}`,
        JSON.stringify(physician),
        httpOptions
      )
      .pipe(
        switchMap((response: any) => {
          finalResponse = response;
          // Get the signed url

          if (
            response &&
            response.s_url &&
            signfile &&
            response.ppurl &&
            ppFile
          ) {
            return merge(
              this.http.put(response.s_url, signfile),
              this.http.put(response.ppurl, ppFile)
            );
          }
          if (response && response.ppurl && ppFile) {
            return this.http.put(response.ppurl, ppFile);
          }
          if (response && response.s_url && signfile) {
            return this.http.put(response.s_url, signfile);
          }
          return of(response);
        })
      )
      .pipe(
        switchMap(() => {
          return of(finalResponse);
        })
      );
  }

  payouts(uid, data): Observable<Transactions> {
    return this.http.post<Transactions>(
      environment.api_base_url3 + `physicians/payouts/${uid}`,
      JSON.stringify(data),
      httpOptions
    );
  }

  getAppHabbitList(): Observable<{}[]> {
    return this.http.get<{}[]>(
      environment.api_base_url3 + "/masterdata/appetite_habits"
    );
  }

  getDiseaseList(): Observable<{}[]> {
    return this.http.get<{}[]>(
      environment.api_base_url3 + "masterdata/diseases"
    );
  }

  getMasterList(type): Observable<{}[]> {
    return this.http.get<{}[]>(
      environment.api_base_url3 + `masterdata/${type}`
    );
  }

  getStates(country): Observable<{}[]> {
    let res;
    return res = this.http.get<{}[]>(
      environment.api_base_url3 + `masterdata/countries/${country}/states`
    );
    console.log(res);
  }

  getSmcs(): Observable<{}[]> {
    return this.http.get<{}[]>(environment.api_base_url3 + `masterdata/smc`);
  }

  updatePatient(
    id,
    patient: AllPatient,
    ppFile: File = null
  ): Observable<AllPatient> {
    let finalResponse = null;
    return this.http
      .put<AllPatient>(
        environment.api_base_url3 + `patients/${id}`,
        JSON.stringify(patient),
        httpOptions
      )
      .pipe(
        switchMap((response: any) => {
          finalResponse = response;
          // Get the signed url
          if (response && response.ppurl && ppFile) {
            return this.http.put(response.ppurl, ppFile);
          }

          return of(response);
        })
      )
      .pipe(
        switchMap(() => {
          return of(finalResponse);
        })
      );
  }
  newupdatePatient(
    id,
    patient: AllPatient,
    ppFile: File = null
  ): Observable<AllPatient> {
    let finalResponse = null;
    return this.http
      .put<AllPatient>(
        environment.api_base_url3 + `newpatients/${id}`,
        JSON.stringify(patient),
        httpOptions
      )
      .pipe(
        switchMap((response: any) => {
          finalResponse = response;
          // Get the signed url
          if (response && response.ppurl && ppFile) {
            return this.http.put(response.ppurl, ppFile);
          }

          return of(response);
        })
      )
      .pipe(
        switchMap(() => {
          return of(finalResponse);
        })
      );
  }

  getPatientById(id, queryParam = ""): Observable<AllPatient> {
    return this.http
      .get<AllPatient>(
        environment.api_base_url3 + `patients/${id}${queryParam}`
      )
      .pipe(
        switchMap((response: any) => {
          return of(response);
        })
      );
  }

  fetchOrganisationById(id: String): Observable<Organisation> {
    return this.http
      .get<Organisation>(environment.api_base_url3 + `organisations/${id}`)
      .pipe(
        switchMap((res) => {
          if (res && res.opurl) {
            res.opurl = environment.content_base_url + "/" + res.opurl;
          } else {
            res.opurl =
              environment.content_base_url + "/" + environment.dummy_img;
          }
          return of(res);
        })
      );
  }

  updateOrganisation(
    id,
    organisation: Organisation,
    ppFile: File
  ): Observable<Organisation> {
    let finalResponse = null;
    return this.http
      .put<Organisation>(
        environment.api_base_url3 + `/organisations/${id}`,
        JSON.stringify(organisation),
        httpOptions
      )
      .pipe(
        switchMap((response: any) => {
          finalResponse = response;
          // Get the signed url
          if (response && response.opurl && ppFile) {
            return this.http.put(response.opurl, ppFile);
          }

          return of(response);
        })
      )
      .pipe(
        switchMap(() => {
          return of(finalResponse);
        })
      );
  }

  // Delete Invoice bills
  deleteInvoice(invoice_id: number): Observable<any[]> {
    console.log(environment.api_base_url3 + "/org_srv/" + invoice_id + "/services")
    return this.http.delete<OrgService[]>(
      environment.api_base_url3 + "/org_srv/" + invoice_id + "/services",
      httpOptions
    );
  }

  // Delete Labrecord_id
  deleteLabtest(Labrecord_id: number): Observable<any[]> {
    console.log(environment.api_base_url3 + "/patients/" + Labrecord_id + "/labtests")
    return this.http.delete<OrgService[]>(
      environment.api_base_url3 + "/patients/" + Labrecord_id + "/labtests",
      httpOptions
    );
  }

  // Delete Invoice bills
  deletePrescri(prescri_id: number): Observable<any[]> {
    console.log(environment.api_base_url3 + "/patients/" + prescri_id + "/prescriptions")
    return this.http.delete<OrgService[]>(
      environment.api_base_url3 + "/patients/" + prescri_id + "/prescriptions",
      httpOptions
    );
  }

  // fetch organisation services
  getOrgService(org_code): Observable<OrgService[]> {
    return this.http.get<OrgService[]>(
      environment.api_base_url3 + "/org_srv/" + org_code
    );
  }

  // fetch organisation services
  getFeedbackdr(uid): Observable<any[]> {
    console.log(environment.api_base_url3 + "physicians/" + uid + "/feedbacks")
    return this.http.get<any[]>(
      environment.api_base_url3 + "physicians/" + uid + "/feedbacks",
      httpOptions
    );
  }
  // delete organisation services

  deleteOrgService(service_id: number): Observable<OrgService[]> {
    return this.http.delete<OrgService[]>(
      environment.api_base_url3 + "/org_srv/" + service_id,
      httpOptions
    );
  }

  // update organisation services

  updateOrgService(sid: number, input): Observable<OrgService[]> {
    return this.http.put<OrgService[]>(
      environment.api_base_url3 + "/org_srv/" + sid + input.org_code,
      { ...input },
      httpOptions
    );
  }

  addOrgSrv(orgsrvs: OrgService): Observable<OrgService> {
    return this.http.post<OrgService>(
      environment.api_base_url3 + "/org_srv/",
      JSON.stringify(orgsrvs),
      httpOptions
    );
  }

  getNotificationByUser(
    id: number,
    page: number,
    count: number
  ): Observable<OrgService> {
    return this.http.get<any>(
      `${environment.api_base_url3}/users/notificaton/${id}?page=${page}&count=${count}`
    );
  }

  updateNotification(id, body: any): Observable<OrgService> {
    return this.http.put<any>(
      `${environment.api_base_url3}/users/notificaton/${id}`,
      JSON.stringify(body),
      httpOptions
    );
  }

  getConferenceToken(aptid, role): Observable<any> {
    return this.http.get<any>(
      `${environment.api_base_url3}/users/conference/token?aptid=${aptid}&role=${role}`
    );
  }

  getAppointmentDetails(
    params,
    queryParam = "",
    pagination = ""
  ): Observable<any> {
    console.log("params", params)
    console.log(environment.api_base_url1 +
      "appoint/getAppointment" +
      `?${queryParam}${pagination}`)
    return this.http
      .post<any>(
        environment.api_base_url1 +
        "appoint/getAppointment" +
        `?${queryParam}${pagination}`,
        JSON.stringify(params),
        httpOptions
      )
      .pipe(
        switchMap((res) => {
          if (res && res.physician_details) {
            if (res.physician_details.ppurl) {
              res.physician_details.ppurl =
                environment.content_base_url +
                "/" +
                res.physician_details.ppurl;
            } else {
              res.physician_details.ppurl =
                environment.content_base_url +
                "/" +
                environment.dummy_physician_img;
            }
          }
          if (res && res.documents && res.documents.length > 0) {
            for (let doc of res.documents) {
              if (doc.key)
                doc.previewUrl = environment.content_base_url + "/" + doc.key;
            }
          }
          return of(res);
        })
      );
  }

  getPatientAppointments(data = null): Observable<any> {
    return this.http.post<any>(
      environment.api_base_url1 + "appoint/getAppointment",
      { pid: JSON.parse(localStorage.getItem("uid")), ...data },
      httpOptions
    );
  }

  getPatientAppointmentsSuperadmin(
    data = null
  ): Observable<patientAppointment[]> {
    return this.http.post<patientAppointment[]>(
      environment.api_base_url1 + "appoint/getAppointment",
      JSON.stringify(data),
      httpOptions
    );
  }

  getAppointmentSuperadmin(queryParam = ""): Observable<any> {
    return this.http.get<any>(
      environment.api_base_url3 + `/appointment${queryParam}`,
      httpOptions
    );
  }

  getDefaultConsulataionShare(): Observable<{}[]> {
    return this.http.get<{}[]>(
      environment.api_base_url3 + `masterdata/defaultconsultationshare`
    );
  }

  updatedefaultPayout(data): Observable<any> {
    return this.http.put<any[]>(
      environment.api_base_url3 + "/masterdata/defaultconsultationshare",
      JSON.stringify(data),
      httpOptions
    );
  }
  /**
   *
   * @param data
   * upload documents for appointments
   */

  uploadDocs(data, files): Observable<any> {
    console.log("data", data)
    console.log("url - ", environment.api_base_url3 + "upload", data,)
    return this.http
      .post<any>(environment.api_base_url3 + "upload", data, httpOptions)
      .pipe(
        switchMap((res) => {
          console.log("res", res)
          if (res && res.length > 0) {
            console.log("res.length", res.length)
            let requests = [];

            res.forEach((doc, index) => {
              console.log("doc", doc)
              console.log("index", index)
              console.log("doc.signedUrl", doc.signedUrl)
              console.log("files[index]", files[index])
              console.log("this.http.put(doc.signedUrl, files[index])", this.http.put(doc.signedUrl, files[index]))
              console.log("requests", requests)
              requests.push(this.http.put(doc.signedUrl, files[index]));
              console.log("requests end", requests)
            });
            console.log("forkJoin(requests)", forkJoin(requests))
            return forkJoin(requests);
          }
          return of(res);
        })
      );
  }

  uploadFile(data, file): Observable<any> {
    return this.http
      .post<any>(environment.api_base_url3 + "upload/file", data, httpOptions)
      .pipe(
        switchMap(async (res) => {
          await axios.put(res.signedUrl, file, {
            headers: {
              "Content-Type": file.type,
            },
          });
          return res;
        })
      );
  }

  // download function in sls3
  downloadFile(data, file): Observable<any> {
    console.log(environment.api_base_url3 + "download/file");
    return this.http.post<any>(
      environment.api_base_url3 + "download/file",
      data,
      httpOptions
    )
      .pipe(
        switchMap(async (res) => {
          return res;
        })
      );
  }
  uploadFiles(data, file): Observable<any> {
    console.log("uploadFile", data)
    console.log("uploadFile", file)
    return this.http.post<any>(
      environment.api_base_url3 + "uploads/file",
      data,
      httpOptions
    ).pipe(
      switchMap(async (res) => {
        await axios.put(res.signedUrl, file, {
          headers: {
            "Content-Type": file.type
          },
        })
        return of(res);
      })
    )
  }
  uploadDocDocs(data, files): Observable<any> {
    return this.http
      .post<any>(environment.api_base_url3 + "uploads", data, httpOptions)
      .pipe(
        switchMap((res) => {
          if (res && res.length > 0) {
            let requests = [];
            res.forEach((doc, index) => {
              requests.push(this.http.put(doc.signedUrl, files[index]));
            });
            return forkJoin(requests);
          }
          return of(res);
        })
      );
  }


  addServicecharge(data) {
    console.log("servicechargeeeeeeeeeeeee");
    console.log(data);
    return this.http.post<OrgService>(
      environment.api_base_url3 + "org_srv/add",
      JSON.stringify(data),
      httpOptions
    );
  }

  //get labtests from Phys Dashboard for Bill Generation This json displayed on select Box

  getLablists(orgcode): Observable<{}[]> {
    console.log(environment.api_base_url3 + `/org_srv/${orgcode}`);
    return this.http.get<{}[]>(
      //environment.api_base_url3 + `masterdata/diseases/${orgcode}`
      environment.api_base_url3 + `/org_srv/${orgcode}`
    );
  }


  getAppLablists(id: any): Observable<{}[]> {
    console.log(environment.api_base_url3 + `/org_srv/${id}/services`);
    return this.http.get<{}[]>(
      environment.api_base_url3 + `/org_srv/${id}/services`,
      httpOptions
    );
  }


  // getAppLablists(id): Observable<{}[]> {
  //   console.log(environment.api_base_url3 + `/org_srv/${id}/services`);
  //   return this.http.get<{}[]>(
  //     environment.api_base_url3 + `/org_srv/${id}/services`,
  //     httpOptions
  //   );
  // }

  generateCoupon(data): Observable<CouponDetails> {
    return this.http.post<CouponDetails>(
      environment.api_base_url3 + "coupons",
      JSON.stringify(data),
      httpOptions
    );
  }

  fetchCoupons(queryParam = ""): Observable<CouponDetails[]> {
    return this.http.get<CouponDetails[]>(
      environment.api_base_url3 + `coupons${queryParam}`,
      httpOptions
    );
  }

  updateCoupons(id, data, queryParam = ""): Observable<CouponDetails> {
    return this.http.put<CouponDetails>(
      environment.api_base_url3 + `coupons/${id}${queryParam}`,
      JSON.stringify(data),
      httpOptions
    );
  }

  addCoupons(id, data): Observable<CouponDetails> {
    return this.http.post<CouponDetails>(
      environment.api_base_url3 + `coupons/${id}/patients`,
      JSON.stringify(data),
      httpOptions
    );
  }

  deletePatientCoupon(id, pid): Observable<CouponDetails> {
    return this.http.delete<CouponDetails>(
      environment.api_base_url3 + `coupons/${id}/patients/${pid}`,
      httpOptions
    );
  }

  deleteCouponUsage(id, pid): Observable<CouponDetails> {
    return this.http.delete<CouponDetails>(
      environment.api_base_url1 + `coupons/${id}/${pid}`,
      httpOptions
    );
  }

  deleteCoupon(id): Observable<CouponDetails> {
    return this.http.delete<CouponDetails>(
      environment.api_base_url3 + `coupons/${id}`,
      httpOptions
    );
  }

  fetchRoomIDPhy(data, queryParam = ""): Observable<ChatMessages> {
    return this.http.put<ChatMessages>(
      environment.api_base_url3 + `/chatroom?${queryParam}`,
      JSON.stringify(data),
      httpOptions
    );
  }


  // dash board values
  admindashboardvalues(orgcode) {
    return this.http
      .post(
        environment.api_base_url3 + "/physicians/admindashboard",
        JSON.stringify(orgcode),
        httpOptions
      )
  }

  // Fetch current appointment for the Physician
  getCurrentAppointment(data) {
    return this.http.post<PatLabTest>(
      environment.api_base_url3 + "physician/current_appointment",
      JSON.stringify(data),
      httpOptions
    );
  }
  PatientOrganisation(
    data
  ): Observable<Organisation> {
    let finalResponse = null;
    return this.http
      .post<Organisation>(
        environment.api_base_url3 + `/organisations/patient`,
        JSON.stringify(data),
        httpOptions
      )

  }

  requestOrgOTP(phone): Observable<any> {
    return this.http.post<any>(
      environment.api_base_url3 + "organisation/otp",
      JSON.stringify(phone),
      httpOptions
    );
  }
  validateOrgOTP(body): Observable<any> {
    return this.http.put<any>(
      environment.api_base_url3 + "organisation/otp",
      JSON.stringify(body),
      httpOptions
    );
  }
  PatientOrganisationOTP(
    data
  ): Observable<Organisation> {
    let finalResponse = null;
    return this.http
      .post<Organisation>(
        environment.api_base_url3 + `/organisation/org`,
        JSON.stringify(data),
        httpOptions
      )

  }

  createroomforinperson(input): Observable<any> {
    console.log("input  input", input)
    return this.http.post<any>(
      environment.api_base_url1 + "patient/consult",
      JSON.stringify(input),
      httpOptions
    );
  }

}
